const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

export const api = {
  async request(endpoint: string, options: RequestInit = {}) {
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers,
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: 'Network error' }));
      throw new Error(error.error || error.message || 'Request failed');
    }

    return response.json();
  },

  vacancies: {
    getAll: () => api.request('/public/vacancies'),
    getById: (id: string) => api.request(`/public/vacancies/${id}`),
  },

  projects: {
    getAll: () => api.request('/public/projects'),
    getById: (id: string) => api.request(`/public/projects/${id}`),
  },

  vacancyApplications: {
    submit: (data: {
      name: string
      email: string
      phone: string
      message?: string
      vacancyId: string
      vacancyTitle: string
      resumeFileName: string
      resumeMimeType: string
      resumeBase64: string
      consent: boolean
      website?: string
    }) =>
      api.request('/vacancy-application', {
        method: 'POST',
        body: JSON.stringify(data),
      }),
  },
};
